<template>
  <div>
    <div class="add_tag_view  multiple_item_view_box">
      <h4 class="mr-2">
        Social Media
      </h4>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="outline-primary"
        @click="addInput"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-25"
        />
      </b-button>
    </div>

    <div>
      <div class="row">
        <div
          v-for="(item, index) in socia_media"
          :key="index"
          class="col-md-12 mb-2"
        >
          <div class="row">
            <div :class="update ? 'col-md-4' : 'col-md-5'">
              <b-form-select
                id="h-sub-categories"
                v-model="item.type"
                :options="social_media_option"
              />
            </div>
            <div :class="update ? 'col-md-5' : 'col-md-5'">
              <b-form-input
                id=""
                v-model="item.link"
                type="text"
                placeholder="link"
              />
            </div>
            <div
              class="d-flex align-items-center"
              :class="update ? 'col-md-3' : 'col-md-2'"
            >
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0"
                @click="removeInput(index)"
              >
                <feather-icon
                  icon="XIcon"
                  class="mr-25"
                />
              </b-button>
              <b-button
                v-if="update === true"
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-success"
                class="ml-2"
                @click="updateInput(index)"
              >
                <feather-icon
                  icon="CheckIcon"
                  class="mr-25"
                />
              </b-button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {
  BFormInput, BButton, BFormSelect,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { heightTransition } from '@core/mixins/ui/transition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BFormInput,
    BButton,
    BFormSelect,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  props: {
    update: { type: Boolean, default: false },
    id: { type: Number, default: null },
  },
  data() {
    return {

    }
  },
  computed: {
    profile_params() {
      return this.$store.state.businessProfile.admin_param
    },
    socia_media: {
      get() {
        return this.$store.state.socialMedia.socia_media
      },
      set(value) {
        return value
      },
    },
    social_media() {
      return this.$store.state.businessProfile.socal_media_list
    },
    social_media_option() {
      return this.social_media.map(item => {
        const data = { value: item.name, text: item.name }
        return data
      })
    },
    userData() {
      return this.$store.state.auth.user
    },
  },
  mounted() {
    this.getSocialMedia()
  },

  methods: {
    getSocialMedia() {
      return this.$store.dispatch('businessProfile/getSocialMedia')
    },
    getBusinessProfile() {
      if (this.userData.user_info.user_type === 'member') {
        this.$store.dispatch('businessProfile/getProfileVendor', this.profile_params)
      } else {
        this.$store.dispatch('businessProfile/getBusinessProfile', this.profile_params)
      }
    },
    addInput() {
      this.socia_media.push({
        type: '',
        link: '',
      })
    },
    removeInput(index) {
      const item = this.socia_media[index]
      const dom = this
      if (item.id !== undefined) {
        this.$store.dispatch('socialMedia/deleteSocialMediaHandle', item.id)
        setTimeout(() => {
          dom.getBusinessProfile()
        }, 300)
      }
      this.socia_media.splice(index, 1)
    },
    updateInput(index) {
      const item = this.socia_media[index]
      const dom = this
      if (item.link !== '' && item.link !== '') {
        let data

        if (item.id === undefined || item.id === null) {
          data = {
            business_profile_id: this.id,
            social_handles: [item],
          }
          this.$store.dispatch('socialMedia/addSocialMediaHandle', data)
          setTimeout(() => {
            dom.getBusinessProfile()
          }, 300)
        } else {
          data = item
          this.$store.dispatch('socialMedia/updateSocialMediaHandle', data)
          setTimeout(() => {
          dom.getBusinessProfile()
        }, 300)
        }
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Fill the form fields before you can save',
            icon: 'AlertTriangleIcon',
            text: '',
            variant: 'danger',
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
